import React from 'react';
import shortid from 'shortid';

interface IProps {
    /** Source of image to display */
    src: string;
    /** alt attribute of image element */
    alt?: string;
    /** Custom classname appended to image element */
    className?: string;
    /** Custom style object for image */
    style?: any;
    /** Custom click handler for image */
    onClick?: any;
}

const placeholder: string = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=';

const LazyImage: React.FC<IProps> = (props: IProps): any => {
    const generatedId: string = shortid.generate();
    const [source, setSource] = React.useState(placeholder);
    const imageRef: any = React.useRef(null as any);

    React.useEffect(() => {
        let observer: any;
        let didCancel: boolean = false;
        const reference: any = imageRef.current
        if(reference && source === placeholder){
            if(IntersectionObserver){
                observer = new IntersectionObserver(
                    entries => {
                        entries.forEach(entry => {
                            if(!didCancel && (entry.intersectionRatio > 0 || entry.isIntersecting)){
                                setSource(props.src);
                            }
                            // if(!entry.isIntersecting){ setSource(placeholder); }
                        });
                    }, 
                    { threshold: 0.001, rootMargin: '500px 0px' }
                );
                observer.observe(reference);
            }
        }else{ setSource(placeholder) }
        return () => {
            didCancel = true;
            if(observer && observer.unobserve){
                observer.unobserve(reference);
            }
        }
    // eslint-disable-next-line 
    }, [props.src])

    const imageProps = (({ src, ...p }) => p)(props);
    return(
        <img
            id={generatedId}
            ref={imageRef} 
            src={source}
            alt={props.alt}
            {...imageProps} 
        />);
}  

LazyImage.defaultProps = {
    alt: "",
    style: {},
    className: "",
    onClick: () => null
}

export default LazyImage;